import React from 'react';
import { TopBar } from '../components/TopBar';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { Differentiator } from '../components/Differentiator';
import { Methodology } from '../components/Methodology';
import { Testimonials } from '../components/Testimonials';
import { Includes } from '../components/Includes';
import { TargetAudience } from '../components/TargetAudience';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-cream font-sans selection:bg-brand-gold/30 selection:text-brand-dark" data-id="element-245">
      <TopBar data-id="element-246" />
      <main data-id="element-247">
        <Hero data-id="element-248" />
        <PainSection data-id="element-249" />
        <Differentiator data-id="element-250" />
        <Methodology data-id="element-251" />
        <Testimonials data-id="element-252" />
        <Includes data-id="element-253" />
        <TargetAudience data-id="element-254" />
        <Pricing data-id="element-255" />
        <FAQ data-id="element-256" />
      </main>

      <footer className="bg-brand-dark text-gray-400 py-8 text-center text-sm" data-id="element-257">
        <div className="max-w-7xl mx-auto px-4" data-id="element-258">
          <p className="mb-2" data-id="element-259">
            Este producto no sustituye el consejo médico profesional. Consulte
            siempre a su pediatra.
          </p>
          <p data-id="element-260">
            © {new Date().getFullYear()} Protocolo Intestino Limpio. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}